module.exports = __webpack_public_path__ + "img/project-cover3.bca1d5e1.png";